import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { CONTACT_INFO } from '@/utils/constants';
import CTA from "@/components/CTA";
export default function Footer() {
    return (
        <>
            <CTA />
            <footer className="footer" data-testid="footer">
                <div className="container">
                    <div className="footer-grid">
                        <div className="footer-about">
                            <div className="footer-logo">
                                <div className="logo-text">Laxmi Finsec Consultant</div>
                                <div className="logo-subtext">Pvt. Ltd.</div>
                            </div>
                            <div className="footer-contact">
                                <p className="contact-item">
                                    <Phone size={16} />
                                    <a href={`tel:${CONTACT_INFO.phone.replace(/[^0-9+]/g, '')}`}>{CONTACT_INFO.phone}</a>
                                </p>
                                <p className="contact-item">
                                    <Mail size={16} />
                                    <a href={`mailto:${CONTACT_INFO.email}`}>{CONTACT_INFO.email}</a>
                                </p>
                                <p className="contact-item">
                                    <MapPin size={16} />
                                    <span>{CONTACT_INFO.address}</span>
                                </p>
                            </div>
                        </div>

                        <div className="footer-links">
                            <h4>Personal Loans</h4>
                            <ul>
                                <li><Link to="/women-group-loan">Women Group Loan</Link></li>
                                <li><Link to="/personal-loan">Personal Loan</Link></li>
                                <li><Link to="/education-loan">Education Loan</Link></li>
                                <li><Link to="/itr-loan">ITR Loan</Link></li>
                                <li><Link to="/payslip-loan">Payslip Loan</Link></li>
                            </ul>
                        </div>

                        <div className="footer-links">
                            <h4>Property Loans</h4>
                            <ul>
                                <li><Link to="/agriculture-loan">Agriculture Loan</Link></li>
                                <li><Link to="/business-loan">Business Loan</Link></li>
                                <li><Link to="/shop-loan">Shop Loan</Link></li>
                                <li><Link to="/home-loan">Home Loan</Link></li>
                                <li><Link to="/property-loan">Property Loan</Link></li>
                            </ul>
                        </div>

                        <div className="footer-links">
                            <h4>Quick Links</h4>
                            <ul>
                                <li><Link to="/about">About Us</Link></li>
                                <li><Link to="/contact">Contact Us</Link></li>
                                <li><a href="#services">Services</a></li>
                                <li><a href="#emi-calculator">EMI Calculator</a></li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="footer-bottom">
                    <div className="container">
                        <p>Laxmi Finsec Consultant Pvt. Ltd.</p>
                    </div>
                </div>
            </footer>
        </>
    );
};
